import { mpx } from '@didi/es-mpx-creator'

// 获取加解密key
export const getCategoryMenu = () => {
  const params = {};
  return mpx.$http.get('/esapp/category/mine/menu', { params, silent: true })
}